import PropTypes from "prop-types";
import {Dropdown} from "react-bootstrap";
import {Icons} from "../Icons.jsx";
import {ExportToExcel} from "../ExportToExcel.jsx";
import {CopyDataToClipboard} from "../CopyDataToClipboard.jsx";

const ExportTableDataSelect = (props) => {
    const {tableInstance} = props

    const getExportData = () => {
        if (!tableInstance) {
            return [];
        }

        const filteredRows = tableInstance.getFilteredRowModel()?.rows || [];
        const visibleColumns = tableInstance.getVisibleLeafColumns() || [];

        if (filteredRows.length === 0) {
            return [];
        }

        return filteredRows.map(row => {
            const rowData = {};
            visibleColumns.forEach(col => {
                const columnId = col.id;
                const columnHeader = col.columnDef.header || columnId; // Use header as key

                let cellValue = '';
                if (row.original && row.original[columnId] !== undefined) {
                    cellValue = row.original[columnId];
                } else {
                    const cell = row.getVisibleCells().find(cell => cell.column.id === columnId);
                    if (cell) {
                        try {
                            cellValue = cell.getValue() ?? '';
                        } catch (e) {
                            cellValue = '';
                        }
                    }
                }

                if (Array.isArray(cellValue)) {
                    rowData[columnHeader] = cellValue.join(', ');
                } else if (typeof cellValue === 'object' && cellValue !== null) {
                    rowData[columnHeader] = JSON.stringify(cellValue);
                } else {
                    rowData[columnHeader] = cellValue;
                }
            });
            return rowData;
        });
    };

    return (
        <>
            <Dropdown autoClose="inside" className={props.className}>
                <Dropdown.Toggle
                    className={`btn-secondary${props.toggleClassName ? ' ' + props.toggleClassName : ''}`}
                    id="dropdown-autoclose-outside"
                >
                    <Icons.excel size={24} className={'me-1'} />
                    Eksportuj dane
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item>
                        <ExportToExcel
                            text={'Eksportuj do Excel'}
                            data={getExportData()}
                            fileName={(props.fileName + '.xlsx') || 'exported_data.xlsx'}
                        />
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <CopyDataToClipboard data={getExportData()} text={'Kopiuj dane do schowka (CSV)'}/>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}
export default ExportTableDataSelect

ExportTableDataSelect.propTypes = {
    tableInstance: PropTypes.object.isRequired,
    className: PropTypes.string,
    toggleClassName: PropTypes.string,
    fileName: PropTypes.string
}